<div class="role-form">
    <h2>{{ roleId ? 'Edit' : 'Add' }} Role </h2>

    <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">

        <div class="custom-form-group">
            <label class="custom-label" for="">Role Name
                <span class="star" style="display: inline-block !important;">*</span>
            </label>
            <div class="custom-form-control">
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Role Name" formControlName="role_name">
                    <mat-error *ngIf="roleForm.controls['role_name'].invalid && roleForm.controls['role_name'].touched">
                        Role name is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="button-group" style="display: flex; justify-content: space-between; align-items: center;" fxLayoutAlign="end end" style="margin-top:auto;">
            <button mat-button type="button" color="warn" (click)="onCancel()">Cancel</button>

            <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="15px">
                <button type="submit" mat-button class="global-btn btn btn-sm">{{ roleId ? 'Update' : 'Add' }}</button>
            </div>
        </div>

    </form>
</div>